<template>
  <span v-if="truncated" v-tooltip="value">{{ truncated }}</span>
  <template v-else>{{ value }}</template>
</template>

<script>
export default {
  name: "FguTableCellValue",

  props: {
    value: {
      type: [String, Number, Boolean],
      default: null,
    },

    limit: {
      type: Number,
      default: null,
    },
  },

  computed: {
    truncated() {
      const { value, limit } = this;

      if (!limit || typeof value !== "string" || value.length <= limit) {
        return null;
      }

      return `${value.slice(0, limit).trimEnd()}…`;
    },
  },
};
</script>
